import React from 'react'
import SectionHeader from "../SectionHeader/SectionHeader";
import {assetUrl} from "../../serviceApi";

const pie = assetUrl+'images/icon_pieChart.svg'
const filter = assetUrl+'images/icon_purple-filter-list.svg'


const PerformanceAnalysis = (props) => {
    const stylePerformance = "analysis-"
    // const {setActiveComponent} = props
    return (
        <div>
            {/* top nav */}
            {/*<div className={stylePerformance + "top-nav d-flex justify-content-between align-items-center py-3 my-1"}>*/}
            {/*    <p className={stylePerformance + "nav-heading my-1"}>Performance Analysis</p>*/}
            {/*    <img src={cross} alt={"alt"} className={stylePerformance + "icon mx-1"}*/}
            {/*         onClick={() => setActiveComponent("main")}/>*/}
            {/*</div>*/}

            {/*chart*/}
            {/*<AreaChartComponent/>*/}
            {/* list header */}
            <div className={"d-flex justify-content-between align-items-center py-2"}>
                <SectionHeader heading={"Performance Average"} image={pie} viewmore={false}/>
                <button
                    className={stylePerformance + "filterButton d-flex justify-content-between align-items-center p-2"}>
                    <img src={filter} alt={'alt'} className={stylePerformance + " icon"}/>
                    <p className={stylePerformance + "filterButton-text my-0 ml-1"}>Filter</p>
                </button>
            </div>
            {/* list items   */}
            <div className={stylePerformance + "list-item"}>
                <div className={stylePerformance + "list-item-main my-2"}>
                    <p className={stylePerformance + "list-item-heading my-1"}>Average of Mar,21</p>
                    <div className={stylePerformance + "list-item-content mb-2"}>
                        <div className={'d-flex justify-content-between align-items-center'}>
                            <div>
                                <p className={stylePerformance + "list-item-primaryText my-1  positive"}>+ ₹ 38,000</p>
                                <p className={stylePerformance + "list-item-secondaryText my-1 "}>Stock Value</p>
                            </div>
                            <div>
                                <p className={stylePerformance + "list-item-price  my-1 text-right"}>₹ 4,50,000.10</p>
                                <p className={stylePerformance + "list-item-secondaryText my-1  text-right"}>Stock
                                    Value</p>
                            </div>

                        </div>
                        <div className={'d-flex justify-content-between align-items-center'}>
                            <div>
                                <p className={stylePerformance + "list-item-primaryText my-1  positive"}>+ ₹ 38,000</p>
                                <p className={stylePerformance + "list-item-secondaryText my-1 "}>Return</p>
                            </div>
                            <div>
                                <p className={stylePerformance + "list-item-primaryText  my-1 positive text-right"}>+ ₹
                                    38,000</p>
                                <p className={stylePerformance + "list-item-secondaryText my-1  text-right"}>Return</p>
                            </div>
                        </div>

                    </div>
                </div>

                <div className={stylePerformance + "list-item-main my-2"}>
                    <p className={stylePerformance + "list-item-heading my-1"}>Average of Mar,21</p>
                    <div className={stylePerformance + "list-item-content mb-2"}>
                        <div className={'d-flex justify-content-between align-items-center'}>
                            <div>
                                <p className={stylePerformance + "list-item-primaryText my-1  positive"}>+ ₹ 38,000</p>
                                <p className={stylePerformance + "list-item-secondaryText my-1 "}>Stock Value</p>
                            </div>
                            <div>
                                <p className={stylePerformance + "list-item-price  my-1 text-right"}>₹ 4,50,000.10</p>
                                <p className={stylePerformance + "list-item-secondaryText my-1  text-right"}>Stock
                                    Value</p>
                            </div>

                        </div>
                        <div className={'d-flex justify-content-between align-items-center'}>
                            <div>
                                <p className={stylePerformance + "list-item-primaryText my-1  positive"}>+ ₹ 38,000</p>
                                <p className={stylePerformance + "list-item-secondaryText my-1 "}>Return</p>
                            </div>
                            <div>
                                <p className={stylePerformance + "list-item-primaryText  my-1 positive text-right"}>+ ₹
                                    38,000</p>
                                <p className={stylePerformance + "list-item-secondaryText my-1  text-right"}>Return</p>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            {/* reueable header */}
            {/*<ReuseableListHeader heading={"Recommended"} image={pie} viewmore={false}/>*/}
        </div>
    )
}

export default PerformanceAnalysis
